import { render, staticRenderFns } from "./ModalNewDelivery.vue?vue&type=template&id=0e4501aa&scoped=true&"
import script from "./ModalNewDelivery.vue?vue&type=script&lang=js&"
export * from "./ModalNewDelivery.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewDelivery.vue?vue&type=style&index=0&id=0e4501aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4501aa",
  null
  
)

export default component.exports